import { FC } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { REVIEW_ANALYSIS_CAMPAIGN_ROUTE } from 'src/constants/routes'
import { useReviewAnalysisLinkQuery } from 'src/hooks/useReviewAnalysisDateRange'
import { createLink } from 'src/utils/createLink'
import { ConnectPlatforms } from '.'

// /review-analysis/:campaignId/connect[?facilityId=&facilityName=]
// "Add Review Facility" opens it bare; a facility's "Add location" passes the
// facility so the new locations join it.
export const ConnectPlatformsPage: FC = () => {
  const navigate = useNavigate()
  const { campaignId = '' } = useParams<{ campaignId: string }>()
  const [searchParams] = useSearchParams()
  const linkQuery = useReviewAnalysisLinkQuery()
  const facilityId = searchParams.get('facilityId')
  const facilityName = searchParams.get('facilityName')

  const toCampaign = () =>
    navigate(
      createLink(REVIEW_ANALYSIS_CAMPAIGN_ROUTE, {
        params: { campaignId },
        queryParams: linkQuery,
      })
    )

  return (
    <ConnectPlatforms
      campaignId={campaignId}
      facility={
        facilityId && facilityName
          ? { id: facilityId, name: facilityName }
          : undefined
      }
      onBack={toCampaign}
      onCreated={toCampaign}
    />
  )
}
